import { createFileRoute } from "@tanstack/react-router";
import AdminEmailLookupPage from "@/admin/pages/email-lookup";

export interface AdminEmailLookupSearch {
  email?: string;
}

export const Route = createFileRoute("/admin/email-lookup")({
  validateSearch: (search: Record<string, unknown>): AdminEmailLookupSearch => ({
    email: typeof search.email === "string" && search.email ? search.email : undefined,
  }),
  component: AdminEmailLookupPage,
});
